/**
 * Constants, Presets, and Configurations for Aim Assist Training Lab
 * Pure client-side, zero runtime external dependencies
 */

export const GAME_PRESETS = {
  valorant: {
    id: 'valorant',
    name_ar: 'فالورانت (VALORANT)',
    name_en: 'VALORANT',
    yaw: 0.07,
    defaultSens: 0.35,
    defaultDpi: 800,
    defaultFov: 103,
    fovType: 'hor+',
    firstShotAccuracy: 0.99,
    movementPenalty: 0.92,
    recoilSpread: 1.25,
    recoilPitchBase: 0.022,
    recoilYawBase: 0.007,
    recoilRecoveryRate: 9.0,
    recoilResetTimeMs: 320,
    spraySwayAmount: 0.018,
    sprayPattern: [
      { pitch: 0, yaw: 0 },
      { pitch: -0.012, yaw: 0.001 },
      { pitch: -0.024, yaw: -0.001 },
      { pitch: -0.038, yaw: 0.002 },
      { pitch: -0.052, yaw: -0.003 },
      { pitch: -0.064, yaw: 0.004 },
      { pitch: -0.074, yaw: -0.005 },
      { pitch: -0.080, yaw: 0.008 },
      { pitch: -0.082, yaw: -0.012 },
      { pitch: -0.081, yaw: 0.014 },
      { pitch: -0.082, yaw: -0.015 },
      { pitch: -0.080, yaw: 0.016 },
      { pitch: -0.082, yaw: -0.017 },
      { pitch: -0.081, yaw: 0.016 },
      { pitch: -0.082, yaw: -0.016 }
    ],
    headshotRatio: 0.35,
    targetScale: 0.85,
    targetSpeed: 1.0,
    desc_ar: 'تركيز فائق على دقة الطلقة الأولى واستقرار التوقف التام (Counter-Strafing) مع تأرجح أفقي بعد الطلقة 7.',
    desc_en: 'First-shot precision, stationary firing, and visual barrel sway compensation after shot 7.'
  },
  cs2: {
    id: 'cs2',
    name_ar: 'كاونتر سترايك 2 (CS2)',
    name_en: 'Counter-Strike 2',
    yaw: 0.022,
    defaultSens: 1.15,
    defaultDpi: 800,
    defaultFov: 90,
    fovType: '4:3_base',
    firstShotAccuracy: 0.98,
    movementPenalty: 0.95,
    recoilSpread: 1.45,
    recoilPitchBase: 0.026,
    recoilYawBase: 0.014,
    recoilRecoveryRate: 6.2,
    recoilResetTimeMs: 420,
    spraySwayAmount: 0.024,
    sprayPattern: [
      { pitch: 0, yaw: 0 },
      { pitch: -0.015, yaw: 0.002 },
      { pitch: -0.030, yaw: -0.002 },
      { pitch: -0.048, yaw: 0.004 },
      { pitch: -0.065, yaw: -0.006 },
      { pitch: -0.080, yaw: 0.008 },
      { pitch: -0.092, yaw: -0.010 },
      { pitch: -0.098, yaw: 0.014 },
      { pitch: -0.100, yaw: -0.018 },
      { pitch: -0.099, yaw: 0.022 },
      { pitch: -0.100, yaw: -0.024 },
      { pitch: -0.098, yaw: 0.025 },
      { pitch: -0.100, yaw: -0.026 },
      { pitch: -0.099, yaw: 0.025 },
      { pitch: -0.100, yaw: -0.025 }
    ],
    headshotRatio: 0.30,
    targetScale: 0.80,
    targetSpeed: 1.1,
    desc_ar: 'التحكم الدقيق في نمط ارتداد الرصاص الكلاسيكي وسرعة إلغاء الاندفاع الجانبي قبل الضغط على الزناد.',
    desc_en: 'Iconic spray pattern recoil control and strict counter-strafing stabilization.'
  },
  apex: {
    id: 'apex',
    name_ar: 'أبيكس ليجندز (Apex Legends)',
    name_en: 'Apex Legends',
    yaw: 0.022,
    defaultSens: 1.4,
    defaultDpi: 800,
    defaultFov: 110,
    fovType: '4:3_base',
    movementPenalty: 0.25,
    recoilSpread: 0.8,
    recoilPitchBase: 0.014,
    recoilYawBase: 0.007,
    recoilRecoveryRate: 11.0,
    recoilResetTimeMs: 250,
    spraySwayAmount: 0.009,
    sprayPattern: [
      { pitch: 0, yaw: 0 },
      { pitch: -0.010, yaw: 0.002 },
      { pitch: -0.020, yaw: 0.004 },
      { pitch: -0.030, yaw: 0.005 },
      { pitch: -0.038, yaw: 0.003 },
      { pitch: -0.045, yaw: -0.003 },
      { pitch: -0.051, yaw: -0.006 },
      { pitch: -0.056, yaw: -0.007 },
      { pitch: -0.060, yaw: -0.004 },
      { pitch: -0.063, yaw: 0.003 },
      { pitch: -0.066, yaw: 0.006 },
      { pitch: -0.068, yaw: 0.005 }
    ],
    headshotRatio: 0.25,
    targetScale: 0.95,
    targetSpeed: 1.6,
    desc_ar: 'تتبع سلس عالي السرعة مع تقنية تنعيم الارتداد الحركي (Recoil Smoothing).',
    desc_en: 'Fast multi-directional tracking, high mobility, and horizontal recoil smoothing.'
  },
  overwatch: {
    id: 'overwatch',
    name_ar: 'أوفر ووتش 2 (Overwatch 2)',
    name_en: 'Overwatch 2',
    yaw: 0.0066,
    defaultSens: 4.8,
    defaultDpi: 800,
    defaultFov: 103,
    fovType: 'hor+',
    movementPenalty: 0.20,
    recoilSpread: 0.6,
    recoilPitchBase: 0.012,
    recoilYawBase: 0.003,
    recoilRecoveryRate: 10.0,
    recoilResetTimeMs: 240,
    spraySwayAmount: 0.004,
    headshotRatio: 0.25,
    targetScale: 1.0,
    targetSpeed: 1.5,
    desc_ar: 'مزيج ديناميكي بين التتبع السلس والفليك السريع بين أهداف متعددة الأحجام.',
    desc_en: 'Fast target tracking, varied hitboxes, and rapid target acquisition.'
  },
  fortnite: {
    id: 'fortnite',
    name_ar: 'فورتنايت (Fortnite)',
    name_en: 'Fortnite',
    yaw: 0.005555,
    defaultSens: 6.5,
    defaultDpi: 800,
    defaultFov: 80,
    fovType: 'clamped',
    movementPenalty: 0.40,
    recoilSpread: 0.9,
    recoilPitchBase: 0.009,
    recoilYawBase: 0.003,
    recoilRecoveryRate: 8.0,
    recoilResetTimeMs: 280,
    spraySwayAmount: 0.005,
    headshotRatio: 0.25,
    targetScale: 1.1,
    targetSpeed: 1.3,
    desc_ar: 'انتقال خاطف ومفاجئ بين أهداف متباعدة ومسافات متغيرة بسرعة.',
    desc_en: 'Rapid flick transitions between targets at wide angles and variable ranges.'
  },
  cod: {
    id: 'cod',
    name_ar: 'كول أوف ديوتي (Call of Duty: Warzone)',
    name_en: 'Call of Duty: Warzone',
    yaw: 0.0066,
    defaultSens: 5.0,
    defaultDpi: 800,
    defaultFov: 105,
    fovType: 'hor+',
    movementPenalty: 0.35,
    recoilSpread: 0.95,
    recoilPitchBase: 0.026,
    recoilYawBase: 0.008,
    recoilRecoveryRate: 13.0,
    recoilResetTimeMs: 280,
    spraySwayAmount: 0.008,
    sprayPattern: [
      { pitch: 0, yaw: 0 },
      { pitch: -0.016, yaw: 0.002 },
      { pitch: -0.032, yaw: 0.003 },
      { pitch: -0.046, yaw: 0.005 },
      { pitch: -0.058, yaw: 0.006 },
      { pitch: -0.068, yaw: 0.008 },
      { pitch: -0.076, yaw: 0.009 },
      { pitch: -0.083, yaw: 0.010 },
      { pitch: -0.089, yaw: 0.011 },
      { pitch: -0.094, yaw: 0.012 }
    ],
    headshotRatio: 0.20,
    targetScale: 1.05,
    targetSpeed: 1.25,
    desc_ar: 'سرعة فتح السكوب (ADS) والتصويب الخاطف وردود الأفعال السريعة.',
    desc_en: 'Fast aim-down-sights (ADS) snaps and rapid close-to-medium target acquisition.'
  },
  r6: {
    id: 'r6',
    name_ar: 'رينبو 6 سيج (Rainbow Six Siege)',
    name_en: 'Rainbow Six Siege',
    yaw: 0.00572958,
    defaultSens: 12.0,
    defaultDpi: 800,
    defaultFov: 75,
    fovType: 'vertical',
    movementPenalty: 0.80,
    recoilSpread: 1.1,
    recoilPitchBase: 0.028,
    recoilYawBase: 0.010,
    recoilRecoveryRate: 8.5,
    recoilResetTimeMs: 310,
    spraySwayAmount: 0.012,
    sprayPattern: [
      { pitch: 0, yaw: 0 },
      { pitch: -0.018, yaw: 0.003 },
      { pitch: -0.038, yaw: -0.003 },
      { pitch: -0.058, yaw: 0.004 },
      { pitch: -0.076, yaw: 0.006 },
      { pitch: -0.092, yaw: -0.005 },
      { pitch: -0.106, yaw: 0.007 },
      { pitch: -0.118, yaw: -0.006 },
      { pitch: -0.128, yaw: 0.008 },
      { pitch: -0.136, yaw: -0.008 }
    ],
    headshotRatio: 0.40,
    targetScale: 0.82,
    targetSpeed: 1.05,
    desc_ar: 'تصويب دقيق قائم على الزوايا الضيقة وحسابات مجال الرؤية الرأسي (Vertical FOV).',
    desc_en: 'Tight angular holds, pixel peeks, and native vertical FOV projection.'
  },
  thefinals: {
    id: 'thefinals',
    name_ar: 'ذا فاينالز (THE FINALS)',
    name_en: 'THE FINALS',
    yaw: 0.0066,
    defaultSens: 5.0,
    defaultDpi: 800,
    defaultFov: 100,
    fovType: 'hor+',
    movementPenalty: 0.45,
    recoilSpread: 0.85,
    recoilPitchBase: 0.020,
    recoilYawBase: 0.008,
    recoilRecoveryRate: 10.5,
    recoilResetTimeMs: 270,
    spraySwayAmount: 0.010,
    headshotRatio: 0.25,
    targetScale: 1.0,
    targetSpeed: 1.45,
    desc_ar: 'حركة بيئية ثلاثية الأبعاد سريعة وتتبع متواصل للأهداف المتحركة.',
    desc_en: 'High verticality, dynamic environmental movement, and continuous tracking.'
  },
  rust: {
    id: 'rust',
    name_ar: 'رست (Rust)',
    name_en: 'Rust',
    yaw: 0.11247,
    defaultSens: 0.25,
    defaultDpi: 800,
    defaultFov: 90,
    fovType: 'hor+',
    movementPenalty: 0.65,
    recoilSpread: 1.35,
    recoilPitchBase: 0.032,
    recoilYawBase: 0.015,
    recoilRecoveryRate: 5.5,
    recoilResetTimeMs: 380,
    spraySwayAmount: 0.020,
    sprayPattern: [
      { pitch: 0, yaw: 0 },
      { pitch: -0.022, yaw: -0.009 },
      { pitch: -0.046, yaw: -0.018 },
      { pitch: -0.070, yaw: -0.014 },
      { pitch: -0.092, yaw: 0.004 },
      { pitch: -0.112, yaw: 0.016 },
      { pitch: -0.128, yaw: 0.022 },
      { pitch: -0.140, yaw: 0.018 },
      { pitch: -0.150, yaw: -0.006 },
      { pitch: -0.158, yaw: -0.020 },
      { pitch: -0.165, yaw: -0.024 },
      { pitch: -0.170, yaw: -0.014 }
    ],
    headshotRatio: 0.30,
    targetScale: 0.88,
    targetSpeed: 1.1,
    desc_ar: 'ارتداد ثقيل وقوي يتطلب سحب الماوس المستمر وضبط نمط الرش المتدرج.',
    desc_en: 'Heavy mechanical recoil patterns requiring deliberate pull-down compensation.'
  },
  destiny2: {
    id: 'destiny2',
    name_ar: 'ديستني 2 (Destiny 2)',
    name_en: 'Destiny 2',
    yaw: 0.0066,
    defaultSens: 5.0,
    defaultDpi: 800,
    defaultFov: 105,
    fovType: 'hor+',
    movementPenalty: 0.30,
    recoilSpread: 0.75,
    recoilPitchBase: 0.016,
    recoilYawBase: 0.006,
    recoilRecoveryRate: 11.5,
    recoilResetTimeMs: 260,
    spraySwayAmount: 0.006,
    headshotRatio: 0.35,
    targetScale: 1.0,
    targetSpeed: 1.35,
    desc_ar: 'اقتناص نقاط الضعف الدقيقة وتصويب انسيابي عالي الإيقاع.',
    desc_en: 'Precision critical-hit acquisition and fluid dynamic aiming.'
  },
  tf2: {
    id: 'tf2',
    name_ar: 'تيم فورتريس 2 (Team Fortress 2)',
    name_en: 'Team Fortress 2',
    yaw: 0.022,
    defaultSens: 1.20,
    defaultDpi: 800,
    defaultFov: 90,
    fovType: '4:3_base',
    movementPenalty: 0.20,
    recoilSpread: 0.65,
    recoilPitchBase: 0.012,
    recoilYawBase: 0.004,
    recoilRecoveryRate: 12.0,
    recoilResetTimeMs: 220,
    spraySwayAmount: 0.004,
    headshotRatio: 0.25,
    targetScale: 1.05,
    targetSpeed: 1.5,
    desc_ar: 'حركة كلاسيكية سريعة وسرعة استجابة على أهداف ذات سرعات متغيرة.',
    desc_en: 'Classic fast arena movement and reactive flick targeting.'
  },
  pubg: {
    id: 'pubg',
    name_ar: 'ببجي (PUBG: BATTLEGROUNDS)',
    name_en: 'PUBG: BATTLEGROUNDS',
    yaw: 0.007,
    defaultSens: 38,
    defaultDpi: 800,
    defaultFov: 90,
    fovType: 'hor+',
    movementPenalty: 0.75,
    recoilSpread: 1.35,
    recoilPitchBase: 0.038,
    recoilYawBase: 0.018,
    recoilRecoveryRate: 4.6,
    recoilResetTimeMs: 420,
    spraySwayAmount: 0.022,
    sprayPattern: [
      { pitch: 0, yaw: 0 },
      { pitch: -0.022, yaw: 0.003 },
      { pitch: -0.046, yaw: -0.004 },
      { pitch: -0.072, yaw: 0.005 },
      { pitch: -0.098, yaw: -0.006 },
      { pitch: -0.122, yaw: 0.008 },
      { pitch: -0.144, yaw: 0.009 },
      { pitch: -0.164, yaw: -0.008 },
      { pitch: -0.180, yaw: 0.012 },
      { pitch: -0.194, yaw: -0.014 },
      { pitch: -0.206, yaw: 0.015 },
      { pitch: -0.216, yaw: -0.016 }
    ],
    headshotRatio: 0.30,
    targetScale: 0.90,
    targetSpeed: 1.15,
    desc_ar: 'أهداف بعيدة المدى، تقدير مسار الحركة، وإدارة الارتداد الرأسي والأفقي الثقيل.',
    desc_en: 'Long-range precision, leading moving targets, and heavy recoil compensation.'
  },
  custom: {
    id: 'custom',
    name_ar: 'إعداد مخصص (Custom FPS)',
    name_en: 'Custom FPS',
    yaw: 0.022,
    defaultSens: 1.0,
    defaultDpi: 800,
    defaultFov: 100,
    fovType: 'hor+',
    movementPenalty: 0.5,
    recoilSpread: 1.0,
    recoilPitchBase: 0.018,
    recoilYawBase: 0.008,
    recoilRecoveryRate: 8.0,
    recoilResetTimeMs: 300,
    spraySwayAmount: 0.010,
    headshotRatio: 0.25,
    targetScale: 1.0,
    targetSpeed: 1.0,
    desc_ar: 'تخصيص كامل لمعايير التصويب والسرعة وأبعاد الأهداف بحرية تامة.',
    desc_en: 'Fully customized training parameters tailored to your personal playstyle.'
  }
};

export const TRAINING_MODES = {
  precision: {
    id: 'precision',
    name_ar: 'الدقة والفليك (Precision & Flick)',
    name_en: 'Precision & Flicking',
    tag_ar: 'السرعة والدقة',
    tag_en: 'Speed & Accuracy',
    desc_ar: 'ظهور أهداف منفردة في زوايا ومسافات عشوائية لقياس سرعة الاقتناص الخاطف ودقة أول طلقة.',
    desc_en: 'Targets spawn one-by-one at random positions to measure target acquisition time and flick accuracy.',
    targetCount: 1,
    spawnDelay: 150,
    timeoutMs: 2500
  },
  tracking: {
    id: 'tracking',
    name_ar: 'التتبع السلس (Smooth Tracking)',
    name_en: 'Smooth & Reactive Tracking',
    tag_ar: 'تتبع مستمر',
    tag_en: 'Continuous Tracking',
    desc_ar: 'هدف كروي يتحرك بمسارات ثلاثية الأبعاد منحنية ومتغيرة؛ حافظ على مؤشر التصويب بداخله.',
    desc_en: 'Spherical target moves smoothly with sudden direction reversals. Keep your crosshair on target.',
    targetCount: 1,
    spawnDelay: 0,
    timeoutMs: 0
  },
  switching: {
    id: 'switching',
    name_ar: 'التنقل بين الأهداف (Target Switching)',
    name_en: 'Target Switching',
    tag_ar: 'أهداف متعددة',
    tag_en: 'Multi-Target',
    desc_ar: 'تصفية 4 أهداف متزامنة بأسرع وتيرة لتقليل زمن الانتقال بين كل هدف وآخر.',
    desc_en: 'Eliminate 4 simultaneous targets sequentially to minimize transition latency between kills.',
    targetCount: 4,
    spawnDelay: 200,
    timeoutMs: 4000
  },
  reaction: {
    id: 'reaction',
    name_ar: 'سرعة رد الفعل (Quick Reaction)',
    name_en: 'Quick Reaction Challenges',
    tag_ar: 'استجابة حركية',
    tag_en: 'Reflex Trial',
    desc_ar: 'انتظر الإشارة المفاجئة (اتجاه أو زر) ونفذ الاستجابة بأسرع ما يمكنك. النقر المبكر يحسب خطأً.',
    desc_en: 'Wait for randomized visual or key cues. Respond instantly. Premature clicks count as False Starts.',
    targetCount: 1,
    spawnDelay: 1500,
    timeoutMs: 1500
  },
  movement: {
    id: 'movement',
    name_ar: 'الحركة وإطلاق النار (Counter-Strafing)',
    name_en: 'Movement & Counter-Strafing',
    tag_ar: 'حركة وتصويب',
    tag_en: 'Strafing Precision',
    desc_ar: 'تحرك جانبياً بالزرين A و D، وتوقف تماماً قبل إطلاق النار لتجنب تشتت الرصاص وإصابة الأهداف.',
    desc_en: 'Strafe laterally with A/D, fully stop before firing to reset weapon bloom and strike targets.',
    targetCount: 2,
    spawnDelay: 300,
    timeoutMs: 3500
  }
};

export const TRAINING_PROGRAMS = {
  warmup_5m: {
    id: 'warmup_5m',
    name_ar: 'إحماء سريع (5 دقائق)',
    name_en: '5-Minute Warm-up',
    durationTotal: 300,
    stages: [
      { mode: 'precision', duration: 90, name_ar: 'إحماء الفليك والدقة', name_en: 'Flick Calibration' },
      { mode: 'switching', duration: 90, name_ar: 'تنقل سريع بين الأهداف', name_en: 'Target Switching' },
      { mode: 'reaction', duration: 90, name_ar: 'تحدي ردود الأفعال', name_en: 'Reflex Challenge' },
      { mode: 'precision', duration: 30, name_ar: 'اختبار دقة سريع', name_en: 'Speed Retest' }
    ]
  },
  focus_12m: {
    id: 'focus_12m',
    name_ar: 'جلسة تركيز مستهدفة (12 دقيقة)',
    name_en: '12-Minute Focus Session',
    durationTotal: 720,
    stages: [
      { mode: 'precision', duration: 120, name_ar: 'فحص المستوى المرجعي', name_en: 'Baseline Benchmark' },
      { mode: 'tracking', duration: 240, name_ar: 'تدريب تتبع مكثف', name_en: 'Intensive Tracking' },
      { mode: 'movement', duration: 240, name_ar: 'توقف وإطلاق حركة', name_en: 'Counter-Strafing' },
      { mode: 'switching', duration: 120, name_ar: 'اختبار نهائي', name_en: 'Final Retest' }
    ]
  },
  practice_25m: {
    id: 'practice_25m',
    name_ar: 'تمرين كامل متقدم (25 دقيقة)',
    name_en: '25-Minute Full Practice',
    durationTotal: 1500,
    stages: [
      { mode: 'precision', duration: 300, name_ar: 'إحماء فليك متقدم', name_en: 'Advanced Flicking' },
      { mode: 'tracking', duration: 300, name_ar: 'تتبع الأهداف الحركية', name_en: 'Dynamic Tracking' },
      { mode: 'switching', duration: 300, name_ar: 'تنقل متعدد الأهداف', name_en: 'Multi-Target Swaps' },
      { mode: 'movement', duration: 300, name_ar: 'رماية متزامنة مع الحركة', name_en: 'Movement & Firing' },
      { mode: 'reaction', duration: 300, name_ar: 'تحدي استجابة الذروة', name_en: 'Peak Reflex Drill' }
    ]
  },
  free_drill: {
    id: 'free_drill',
    name_ar: 'تمرين حر منفصل',
    name_en: 'Individual Free Drill',
    durationTotal: 60,
    stages: null
  }
};

export const CROSSHAIR_STYLES = [
  { id: 'cross', name_ar: 'صليب كلاسيكي (+)', name_en: 'Classic Cross (+)' },
  { id: 'dot', name_ar: 'نقطة مركزية (•)', name_en: 'Center Dot (•)' },
  { id: 'circle_dot', name_ar: 'دائرة ونقطة (⊙)', name_en: 'Circle + Dot (⊙)' },
  { id: 'cross_gap', name_ar: 'صليب مفتوح المركز', name_en: 'Cross with Center Gap' }
];

export const CROSSHAIR_COLORS = [
  { id: 'cyan', hex: '#38bdf8', name_ar: 'سماوي (Cyan)' },
  { id: 'green', hex: '#22c55e', name_en: 'Electric Green', name_ar: 'أخضر فسفوري' },
  { id: 'yellow', hex: '#eab308', name_en: 'Neon Yellow', name_ar: 'أصفر نيون' },
  { id: 'magenta', hex: '#ec4899', name_en: 'Hot Magenta', name_ar: 'وردي فاقع' },
  { id: 'white', hex: '#ffffff', name_en: 'Crisp White', name_ar: 'أبيض ناصع' }
];

export const TARGET_COLORS = [
  { id: 'cyan', core: '#38bdf8', outer: '#0284c7', name_ar: 'سماوي سايبر' },
  { id: 'purple', core: '#c084fc', outer: '#7e22ce', name_ar: 'بنفسجي نيون' },
  { id: 'orange', core: '#fb923c', outer: '#ea580c', name_ar: 'برتقالي عالي التباين' },
  { id: 'emerald', core: '#34d399', outer: '#059669', name_ar: 'زمردي متوهج' }
];

export const REFLEX_TIERS = [
  {
    id: 'grandmaster',
    minScore: 16000,
    minAccuracy: 90,
    title_ar: 'غراند ماستر (Grandmaster Aim)',
    title_en: 'Grandmaster Aim',
    color: '#c084fc',
    desc_ar: 'أداء احترافي نخبوي متفوق (دقة 90%+ وسرعة اقتناص استثنائية)',
    desc_en: 'Elite esports tier (90%+ accuracy & top-tier reflex acquisition)'
  },
  {
    id: 'apex',
    minScore: 12500,
    minAccuracy: 82,
    title_ar: 'مصوب النخبة (Apex Aim)',
    title_en: 'Apex Aim',
    color: '#38bdf8',
    desc_ar: 'مستوى تنافسي متقدم مع ثبات تصويب عالٍ وانضباط زناد',
    desc_en: 'High competitive tier with solid consistency & trigger discipline'
  },
  {
    id: 'sharpshooter',
    minScore: 8500,
    minAccuracy: 72,
    title_ar: 'قناص متقدم (Sharpshooter)',
    title_en: 'Sharpshooter',
    color: '#34d399',
    desc_ar: 'دقة تصويب قوية وسرعة اقتناص أهداف ممتازة',
    desc_en: 'Strong accuracy and fast target acquisition velocity'
  },
  {
    id: 'marksman',
    minScore: 5000,
    minAccuracy: 60,
    title_ar: 'مصوب متمكن (Marksman)',
    title_en: 'Marksman',
    color: '#facc15',
    desc_ar: 'تحكم جيد في حركة الماوس واستقرار الرماية المنتظمة',
    desc_en: 'Good mouse control and steady shooting rhythm'
  },
  {
    id: 'recruit',
    minScore: 0,
    minAccuracy: 0,
    title_ar: 'متدرب واعد (Recruit Aim)',
    title_en: 'Recruit Aim',
    color: '#94a3b8',
    desc_ar: 'مرحلة بناء الذاكرة العضلية وتثبيت أساسيات التمركز والتصويب',
    desc_en: 'Building foundational muscle memory and crosshair discipline'
  }
];

export const TARGET_SHAPES = [
  { id: 'mixed', name_ar: 'متنوع عشوائي (Mixed)', name_en: 'Mixed Shapes' },
  { id: 'humanoid', name_ar: 'مجسم بشري تكتيكي (Tactical Dummy)', name_en: 'Tactical Dummy' },
  { id: 'sphere', name_ar: 'كروي نيون (Cyber Orb)', name_en: 'Cyber Orb' },
  { id: 'bot', name_ar: 'روبوت قتالي (Combat Bot)', name_en: 'Combat Bot' },
  { id: 'drone', name_ar: 'طائرة مسيرة (Diamond Drone)', name_en: 'Stealth Drone' },
  { id: 'disc', name_ar: 'قرص الرماية (Precision Disc)', name_en: 'Target Disc' }
];

export const TARGET_DEPTH_ZONES = [
  { id: 'all', name_ar: 'نطاقات متغيرة ديناميكية (Dynamic)', name_en: 'Dynamic Multi-Range' },
  { id: 'close', name_ar: 'الاشتباك القريب (4 - 7 أمتار)', name_en: 'Close-Quarters (4-7m)' },
  { id: 'mid', name_ar: 'المدى المتوسط (8 - 14 متراً)', name_en: 'Mid-Range (8-14m)' },
  { id: 'long', name_ar: 'المدى البعيد (16 - 24 متراً)', name_en: 'Long-Range (16-24m)' }
];

export const MOTION_PATTERNS = [
  { id: 'auto', name_ar: 'تلقائي حسب النمط', name_en: 'Auto per Mode' },
  { id: 'strafe', name_ar: 'تحرك جانبي (Lateral Strafe)', name_en: 'Lateral Strafe' },
  { id: 'sine', name_ar: 'موجي سلس (Sine Wave)', name_en: 'Sine Wave' },
  { id: 'evasive', name_ar: 'مناورة تفاعلية (Erratic Jiggle)', name_en: 'Erratic Jiggle' },
  { id: 'static', name_ar: 'ثابت بدون حركة (Static)', name_en: 'Stationary' }
];

export const WEAPON_TYPES = {
  rifle: {
    id: 'rifle',
    name_ar: 'بندقية هجومية (Vandal / AK-47)',
    name_en: 'Assault Rifle (Vandal / AK)',
    tag_ar: 'متوازنة وارتداد تكتيكي',
    tag_en: 'Balanced Tactical',
    magSize: 25,
    fireRateMs: 110,
    reloadTimeSec: 2.1,
    damageBody: 100,
    damageHead: 160,
    firstShotSpread: 0.001,
    sprayMaxSpread: 0.042,
    recoilPitchPerShot: 0.024,
    recoilYawPerShot: 0.008,
    recoilRecoverySpeed: 7.5,
    adsZoom: 1.25,
    scopeType: 'holographic',
    tracerColor: 0x38bdf8,
    modelShape: 'rifle'
  },
  smg: {
    id: 'smg',
    name_ar: 'رشاش خفيف سريع (Spectre / R-99)',
    name_en: 'Rapid SMG (Spectre / R-99)',
    tag_ar: 'معدل إطلاق فائق',
    tag_en: 'High Fire Rate',
    magSize: 32,
    fireRateMs: 72,
    reloadTimeSec: 1.6,
    damageBody: 65,
    damageHead: 110,
    firstShotSpread: 0.004,
    sprayMaxSpread: 0.075,
    recoilPitchPerShot: 0.013,
    recoilYawPerShot: 0.012,
    recoilRecoverySpeed: 9.0,
    adsZoom: 1.15,
    scopeType: 'red_dot',
    tracerColor: 0x22c55e,
    modelShape: 'smg'
  },
  sniper: {
    id: 'sniper',
    name_ar: 'قناصة ثقيلة (Operator / AWP)',
    name_en: 'Heavy Sniper (Operator / AWP)',
    tag_ar: 'أقوى ضرر وتكبير سكوب',
    tag_en: 'High Zoom & Damage',
    magSize: 5,
    fireRateMs: 950,
    reloadTimeSec: 2.8,
    damageBody: 250,
    damageHead: 400,
    firstShotSpread: 0.0001,
    sprayMaxSpread: 0.12,
    recoilPitchPerShot: 0.08,
    recoilYawPerShot: 0.004,
    recoilRecoverySpeed: 4.2,
    adsZoom: 3.2,
    scopeType: 'sniper_overlay',
    tracerColor: 0xfacc15,
    modelShape: 'sniper'
  },
  pistol: {
    id: 'pistol',
    name_ar: 'مسدس تكتيكي (Sheriff / Deagle)',
    name_en: 'Tactical Pistol (Sheriff / Deagle)',
    tag_ar: 'فليك واقتناص يدوي',
    tag_en: 'Precision Semi-Auto',
    magSize: 6,
    fireRateMs: 250,
    reloadTimeSec: 1.7,
    damageBody: 120,
    damageHead: 220,
    firstShotSpread: 0.002,
    sprayMaxSpread: 0.05,
    recoilPitchPerShot: 0.046,
    recoilYawPerShot: 0.006,
    recoilRecoverySpeed: 6.8,
    adsZoom: 1.1,
    scopeType: 'iron_sights',
    tracerColor: 0xf97316,
    modelShape: 'pistol'
  }
};

export const ARENA_THEMES = [
  { id: 'cyber', name_ar: 'سايبر إلكتروني (Cyber Grid)', name_en: 'Cyber Grid', bg: 0x0e172a, floor: 0x1e293b, grid: 0x38bdf8 },
  { id: 'clean', name_ar: 'استوديو رمادي ناصع (Clean Studio)', name_en: 'Clean Studio', bg: 0x1e2430, floor: 0x334155, grid: 0x94a3b8 },
  { id: 'pro_dark', name_ar: 'فحم محترفين (Pro Charcoal)', name_en: 'Pro Charcoal', bg: 0x090d16, floor: 0x0f172a, grid: 0x10b981 },
  { id: 'sunset', name_ar: 'شفق ناري (Sunset Mirage)', name_en: 'Sunset Mirage', bg: 0x22131f, floor: 0x361c2e, grid: 0xf97316 }
];


